import React from 'react';
import {
  Box,
  Heading,
  SimpleGrid,
  Card,
  CardBody,
  Text,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const AdminSystem = () => {
  const navigate = useNavigate();

  const systemSections = [
    {
      title: 'Core Products',
      description: 'View product categories and features',
      route: '/admin/system/products',
      icon: '🏗️',
    },
    {
      title: 'Features Registry',
      description: 'Component capabilities and configurations',
      route: '/admin/system/features',
      icon: '⚙️',
    },
    {
      title: 'Passcodes',
      description: 'Registration access codes and invite controls',
      route: '/admin/system/passcodes',
      icon: '🔑',
    },
    {
      title: 'Plan Settings',
      description: 'Subscription plans, limits, and pricing controls',
      route: '/admin/system/plans',
      icon: '💳',
    },
    {
      title: 'Workflows',
      description: 'Workflow registry and execution settings',
      route: '/admin/system/workflows',
      icon: '🔄',
    },
    {
      title: 'AI Agents',
      description: 'Agent architecture and capability relationships',
      route: '/admin/system/agents',
      icon: '🤖',
    },
    {
      title: 'Capabilities',
      description: 'AI capability matrix and coverage',
      route: '/admin/system/capabilities',
      icon: '🧠',
    },
    {
      title: 'Implementation',
      description: 'System implementation overview',
      route: '/admin/system/implementation',
      icon: '📊',
    },
  ];

  return (
    <Box>
      <Heading size="lg" mb={6}>System</Heading>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
        {systemSections.map((section) => (
          <Card
            key={section.title}
            variant="outline"
            cursor="pointer"
            _hover={{ boxShadow: 'md', borderColor: 'blue.300' }}
            onClick={() => navigate(section.route)}
            transition="all 0.2s"
          >
            <CardBody>
              <Text fontSize="2xl" mb={2}>{section.icon}</Text>
              <Heading size="sm" mb={1}>{section.title}</Heading>
              <Text fontSize="sm" color="gray.500">{section.description}</Text>
            </CardBody>
          </Card>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default AdminSystem;
